
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/recipes",
      function () {
        return require("private-next-pages/resources/recipes/index.tsx");
      }
    ]);
  